import { axiosInstance, axiosInstance1 } from "../services/interceptor";

const useLeaveImport = () => {
  const importLeaveBalance = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance1.post(
      "/leave/admin/import-balance",
      formData
    );
    return response.data;
  };

  const downloadTemplate = async () => {
    const response = await axiosInstance.get(
      "/leave/admin/import-balance/template",
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "leave_balance_template.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return { importLeaveBalance, downloadTemplate };
};

export default useLeaveImport;
